import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, OnInit, Inject } from '@angular/core';

export interface DialogData {
  image: any;
}

@Component({
  selector: 'meu-app-simple-image',
  template: `
    <div class="card card-basic box-shadow">
      <div class="card-header d-flex justify-content-between label-card">
        {{ 'PROFILE.CHANGE_AVATAR.TITLE' | translate }}
      </div>
      <div class="card-body card-body-product">
        <div class="text-center mb-3">
          <img [src]="currentAvatar" alt="{{ 'PROFILE.CHANGE_AVATAR.CURRENT' | translate }}" 
               style="max-width: 200px; max-height: 200px; border-radius: 50%;">
        </div>
        
        <div class="form-group">
          <label for="fileInput">{{ 'PROFILE.CHANGE_AVATAR.CHOOSE_NEW' | translate }}</label>
          <input type="file" 
                 id="fileInput" 
                 class="form-control" 
                 (change)="onFileSelected($event)"
                 accept="image/*">
        </div>
        
        <div *ngIf="newImagePreview" class="text-center mb-3">
          <h5>{{ 'PROFILE.CHANGE_AVATAR.PREVIEW' | translate }}</h5>
          <img [src]="newImagePreview" alt="{{ 'PROFILE.CHANGE_AVATAR.PREVIEW' | translate }}" 
               style="max-width: 200px; max-height: 200px; border-radius: 50%;">
        </div>
      </div>
      
      <div class="card-footer text-muted d-flex justify-content-end">
        <button mat-stroked-button class="btn btn-cancel mr-2" [mat-dialog-close]="">{{ 'PROFILE.CHANGE_AVATAR.CANCEL' | translate }}</button>
        <button mat-stroked-button class="btn btn-update" 
                [disabled]="!newImagePreview"
                [ngClass]="{'btn-save-active': newImagePreview}"
                (click)="saveImage()">{{ 'PROFILE.CHANGE_AVATAR.SAVE' | translate }}</button>
      </div>
    </div>
  `,
  styles: [`
    .card {
      min-width: 400px;
      max-width: 90vw;
      margin: 0 auto;
    }
    .form-control {
      margin-bottom: 10px;
      width: 100%;
    }
    .btn {
      margin-left: 5px;
      min-width: 80px;
    }
    img {
      border: 2px solid #ddd;
      max-width: 100%;
      height: auto;
    }
    .btn-cancel {
      color: #fff !important;
      background-color: #dc3545 !important;
      border-color: #dc3545 !important;
    }
    .btn-update {
      color: #fff !important;
      background-color: #6c757d !important;
      border-color: #6c757d !important;
    }
    .btn-save-active {
      background-color: #28a745 !important;
      border-color: #28a745 !important;
      color: #fff !important;
    }

    /* Mobile responsive */
    @media (max-width: 768px) {
      .card {
        min-width: 320px;
        max-width: 95vw;
        margin: 10px;
      }
      
      .card-header {
        padding: 15px;
        font-size: 16px;
        text-align: center;
      }
      
      .card-body {
        padding: 15px;
      }
      
      .card-footer {
        padding: 15px;
        flex-direction: column-reverse;
        gap: 10px;
      }
      
      .btn {
        width: 100%;
        margin: 0;
        padding: 12px;
        font-size: 16px;
      }
      
      img {
        max-width: 150px;
        max-height: 150px;
      }
      
      .form-group {
        margin-bottom: 15px;
      }
      
      .form-group label {
        font-size: 14px;
        margin-bottom: 8px;
        display: block;
      }
      
      input[type="file"] {
        padding: 10px;
        font-size: 14px;
      }
      
      h5 {
        font-size: 16px;
        margin-bottom: 10px;
      }
    }

    @media (max-width: 480px) {
      .card {
        min-width: 280px;
        max-width: 98vw;
        margin: 5px;
      }
      
      .card-header, 
      .card-body, 
      .card-footer {
        padding: 12px;
      }
      
      img {
        max-width: 120px;
        max-height: 120px;
      }
    }
  `]
})
export class AppSimpleImageComponent implements OnInit {
  currentAvatar: string;
  newImagePreview: string | null = null;
  selectedFile: File | null = null;

  constructor(
    public dialogRef: MatDialogRef<AppSimpleImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit() {
    this.currentAvatar = this.data.image || '/assets/media/users/default.jpg';
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.newImagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  saveImage() {
    if (this.newImagePreview) {
      this.dialogRef.close({ data: this.newImagePreview });
    }
  }
}